<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'活动沙龙'},{name:'活动列表',goback:true},{name:'活动明细'}]" :title="'活动明细'" ref="breadcrumb"/>
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="活动详情" name="1"></el-tab-pane>
              <el-tab-pane label="报名名单" name="2"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" v-show="tab==='2'" ref="condition">
                <div class="left">
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="sendInfoOne.drop" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="sendInfoOne.dropValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                    <el-button @click="exports" size="small"  class="retrievalBtn">导出</el-button>
                </div>
            </div>
            <!-- 主体 -->
            <!-- 产品详情 -->
            <div class="box detailBas detailImg super_boxs" v-show="tab==='1'">
                <el-card class="basic box_card" header="" shadow="never">
                  <div class="basisTitle">基础信息：</div>
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">活动标题：</div>
                        <div class="content">{{dataInfo.activityTitle||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">活动类型：</div>
                        <div class="content">{{dataInfo.activityTypeValue||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">报名截止时间：</div>
                          <div class="content">{{dataInfo.registrationDeadline||'--'}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="child">
                            <div class="name">活动开始时间：</div>
                            <div class="content">{{dataInfo.startDate||'--'}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">活动结束时间：</div>
                          <div class="content">{{dataInfo.endDate||'--'}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">活动举办地址：</div>
                        <div class="content">{{dataInfo.activityAddress||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="child">
                          <div class="name">活动主办单位：</div>
                          <div class="content">{{dataInfo.activityOrganizer||'--'}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child" v-if="dataInfo.fitCrowd&&dataInfo.fitCrowd.length>0">
                          <div class="name">适用人群：</div>
                          <div class="content">
                        <span v-for="(i,index) in dataInfo.fitCrowd" :key="index">
                          {{i.value||'--'}}
                        </span>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="child">
                          <div class="name">来源：</div>
                          <div class="content">{{dataInfo.source||'--'}}</div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    
                    <el-col :span="24">
                        <div class="richText">
                            <div class="name">活动详情：</div>
                            <div class="content" v-html="dataInfo.activityDetails">{{dataInfo.activityDetails||'--'}}</div>
                        </div>
                    </el-col>
                    </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="attachment"  v-if="dataInfo.fileList&&dataInfo.fileList.length>0">
                          <div class="name">附件：</div>
                          <ul class="content">
                          <li v-for="(i,index) in dataInfo.fileList" :key="index">
                            <span>{{i.fileName}}</span>
                            <i class="el-icon-download" @click="downLoad(dataInfo.frontPath+i.filePath)"></i>
                          </li>
                          </ul>
                      </div>
                    </el-col>
                  </el-row>
                </el-card>
                <el-card class="basic box_card" header="" shadow="never">
                  <div class="basisTitle">其它信息：</div>
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">发布账号：</div>
                        <div class="content">{{dataInfo.createUserName||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">发布时间：</div>
                          <div class="content">{{dataInfo.createTime||'--'}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="child">
                            <div class="name">更新账号：</div>
                            <div class="content">{{dataInfo.modifyUserName||'--'}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">更新时间：</div>
                          <div class="content">{{dataInfo.updateTime||'--'}}</div>
                      </div>
                    </el-col>
                  </el-row>
                </el-card>
            </div>
            <!-- 客户申请表格 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="applyCompany"
                    show-overflow-tooltip
                    
                    label="公司全称">
                </el-table-column>
                <el-table-column
                    prop="applyRemark"
                    show-overflow-tooltip
                    
                    width="200"
                    label="说明">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination" v-if="tab === '2'">
            	<Paging
            	:PageData="PageData"
            	@nextpage="nextpage"
            	@previouspage="previouspage"
            	@handleSizeChange="handleSizeChange"
            	@handleCurrentChange="handleCurrentChange"
            	></Paging>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                custom-class="super_dialog"
                width="50%">
                <div class="basic boxChild">
                    <div class="child">
                        <div class="name">姓名：</div>
                        <div class="content">{{dataInfo.applicant||'--'}}</div>
                    </div>
                    <div class="child">
                        <div class="name">联系手机号：</div>
                        <div class="content">{{dataInfo.contactPhone||'--'}}</div>
                    </div>
                    <div class="child">
                        <div class="name">公司全称：</div>
                        <div class="content">{{dataInfo.applyCompany||'--'}}</div>
                    </div>
                    <div class="child">
                        <div class="name">说明：</div>
						<div class="content">{{dataInfo.applyRemark||'--'}}</div>
                    </div>
                    <div class="attachment" v-if="dataInfo.fileList">
                        <div class="name">附件：</div>
                        <ul class="content">
                            <li v-for="(item,index) in dataInfo.fileList" :key="index">
                    			<span>{{item.fileName}}</span>
                    			<i class="el-icon-download" @click="downLoad(item.frontPath+item.filePath)"></i>
                    		</li>
                        </ul>
                    </div>
                </div>
            </el-dialog>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import Paging from '../../components/Paging';
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        Paging
    },
    data(){
        return{
          loading:false,
            bHeight: void 0,
            id:'',//详情id
            tab:'1',//选项卡
			dataInfo:'',
            options: [{
                value: '2',
                label: '申请人姓名'
                }, {
                value: '3',
                label: '联系方式'
            }],//检索下拉
            sendInfoOne:{
                drop:'',//检索下拉值
                dropValue:"",//检索输入值
            },//检索提交数据
			sendInfo:{
				currentPage:1,//当前页
				pageSize:10,//页条数
				property:null,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
				applicant:null,//申请人姓名
				id:'',//申请人id
				loanId:this.$route.query.id,//沙龙id
				contactPhone:'',//申请人号码
			},
			PageData:{
			  currentPage: 0,
			  total: 0, //多少條
			},
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
        }
    },
	created(){
	    if(this.$route.query.id){
	        this.id=this.$route.query.id;
			this.getDetail();
	    }
	},
  mounted(){
    const that = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25 + (that.$refs.breadcrumb?that.$refs.breadcrumb.$el.offsetHeight:0)
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 +25 + (that.$refs.breadcrumb?that.$refs.breadcrumb.$el.offsetHeight:0)
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  },
    methods:{
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        // export
        exports(){
            this.$axiosc.get('/backstage/activity/salon/apply/export/'+this.id).then((res)=>{
                if(res.code==200){
                    var aLink = document.createElement('a');
                    var blob = this.dataURLtoBlob(res.data.bytes);
                    var reader = new FileReader();
                    reader.readAsDataURL(blob);   // 转换为base64，可以直接放入a标签href
                    reader.onload = function (e) {
                        var a = document.createElement('a');   // 转换完成，创建一个a标签用于下载
                        a.download = res.data.fileName;
                        a.href = e.target.result;
                        document.body.appendChild(a);    // 修复firefox中无法触发click
                        a.click();
                        document.body.removeChild(a);
                    }
                }else{
                    this.$alert(res.msg)
                }
            })
        },
		dataURLtoBlob:function(dataurl){
		    let bstr = atob(dataurl),//负责解码已经使用base64编码了的字符串
		        n = bstr.length,
		        u8arr = new Uint8Array(n);
		    while (n--) {
		        u8arr[n] = bstr.charCodeAt(n);
		    }
		    return new Blob([u8arr], {type: 'application/vnd.ms-excel;charset=UTF-8;'});
		},
		getDetail(){
      this.loading = true
			if(this.tab==='1'){
				this.$axiosc.get('/backstage/activity/salon/details/'+this.id).then((r)=>{
				    if(r.code==200){
				        this.dataInfo=r.data;
                this.loading = false
				    }else{
				        this.$alert(r.msg)
                this.loading = false
				    }
				}).catch(e=>{
          this.loading = false
        })
			}else{
				this.$axiosc.get('/backstage/activity/salon/apply/loadId/list',{params:this.sendInfo}).then(res=>{
				    if(res.code==200){
				        this.tableData=res.data.content;
				        this.PageData.currentPage =res.data.currentPage; //当前页
				        this.PageData.total =res.data.totalElements;
                this.loading = false
				    }else{
				        this.$alert(res.msg)
                this.loading = false
				    }
				}).catch(e=>{
          this.loading = false
        })
			}
			
		},
        // 切换选项啦
        changeTab:function(tab){
            const that = this
            that.tab=tab.name;
			      that.getDetail()
            setTimeout(() => {
              let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
              that.bHeight = document.body.clientHeight - 64  - bh 
              that.doLayout()
            }, 100);

        },
        //检索事件
        retrieval:function(){
			let lookData=this.sendInfoOne;
			let lookdell=lookData.drop;
			if(lookdell==1){
				this.sendInfo.id=lookData.dropValue;
				this.sendInfo.applicant=null;
				this.sendInfo.contactPhone=null;
			}else if(lookdell==2){
				this.sendInfo.applicant=lookData.dropValue;
				this.sendInfo.contactPhone=null;
				this.sendInfo.id=null;
			}else if(lookdell==3){
				this.sendInfo.contactPhone=lookData.dropValue;
				this.sendInfo.id=null;
				this.sendInfo.applicant=null;
			}
			this.getDetail()
		},
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='ASC';
            }else{
                order='DESC';
            }
            this.sendInfo.property=prop;
            this.sendInfo.direction=order;
            this.getDetail()
        },
        //查看明细
        check:function(row){
			this.$axiosc.get('/backstage/activity/salon/apply/details/'+row.id).then((r)=>{
			    if(r.code==200){
					this.dataInfo=r.data;
					this.dialogInfo=true;
			    }else{
			        this.$alert(r.msg);
			    }
			})
        },
		//下载附件
		downLoad:function(url){
			window.open(url)
		},
        // 下一頁
        nextpage(val) {
          this.sendInfo.currentPage=val;
          this.getList()();
        },
        // 上一頁
        previouspage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        handleSizeChange(val) {
          this.sendInfo.pageSize = val;
          this.getList()
        },
        handleCurrentChange(val) {
        	this.sendInfo.currentPage=val;
          this.sendInfo.currentPage = val;
          this.getList()
        },
    },
}
</script>

<style lang="scss" scoped>
.super_boxs{
 height:90%;
  overflow-x: hidden;
  overflow-y: auto;
}
.warp{
    height:calc(100% - 35px);
    .detailBas{
        // margin-top: 20px;
    }
}

.box{
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
        p{
          line-height: 30px;
        }
      }
    }
    .tableChild{
      margin-top:10px !important;
    }
    .child,.attachment,.richText{
      margin-top:10px;
    }
}
</style>
<style>
    .box img{
        width: auto;
        height: auto;
        max-width: 100%;
    }
</style>